import baseAPI from "@/api/base";
import { GlobalSearch } from "@/dtos/Search.dto";
import { GLOBAL_SEARCH_URL } from "@/utils/urls";
import { AxiosResponse } from "axios";

class Search {
  static globalSearch = async (globalSearch: GlobalSearch): Promise<AxiosResponse> => {
    const response: AxiosResponse = await baseAPI.get(GLOBAL_SEARCH_URL, {
      params: globalSearch,
    });
    return response;
  };
}

export default Search;
